import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AddIcon from "@mui/icons-material/Add";
import { MdCreate } from "react-icons/md";
import { DisplaySpinnerContext, TabPanelContext } from "../../../../context/ContextIndex";
import DataGridRange from "../../../../components-old/elements/DataGridRange/DataGridRange";
import GridAction from "../../../../components-old/elements/GridAction/GridAction";
import ButtonGroup from "../../../../components-old/elements/ButtonGroup/ButtonGroup";
import { Checkbox } from "@mui/material";
import { IsLoggedInUserViewer } from "../../../../hoc/withAuthRedirect";
import { notifyToast, ToastType } from "../../../../components-old/ComponentsIndex";

const ReplacementDeviceList = ({ onAddClick, setShowForm, setIsFormValid }) => {
  const _tabContextObject = useContext(TabPanelContext);
  const _tabContext = _tabContextObject.getTabFormContext();

  const spinnerCtx = useContext(DisplaySpinnerContext);

  const { t } = useTranslation();

  const [replacementDeviceRecordList, setReplacementDeviceRecordList] = useState([]);
  const [dataGridPageSize, setDataGridPageSize] = useState(10);
  const [totalReplacementDevice, setTotalReplacementDevice] = useState(0);
  const [gridPageSizeOptions] = useState([10, 20, 50]);

  // Set replacement devices after fetching or directly for non-edit cases
  const setReplacementDeviceList = (replacementDeviceList) => {
    const sortedList = [...replacementDeviceList].sort((a, b) => a.StartFrequencyReposition - b.StartFrequencyReposition);

    const updatedList = sortedList.map((item, index) => ({
      id: index,
      ReplaceDeviceId: item.ReplaceDeviceId,
      StartFrequencyReposition: item.StartFrequencyReposition,
      EndFrequencyReposition: item.EndFrequencyReposition,
      RepositionPercentage: item.RepositionPercentage,
      recordResponse: { ...item, Deleted: false },
      deleted: false,
    }));

    setReplacementDeviceRecordList(updatedList);
    setTotalReplacementDevice(updatedList.length);
    spinnerCtx.setLoadingIndicator(false);
  };

  useEffect(() => {
    const replacementDevice = _tabContext.data?.replacementDevice || [];
    if (replacementDevice.length > 0) setReplacementDeviceList(replacementDevice);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEditReplacementDeviceClick = (data) => {
    _tabContextObject.setTabFormContext({
      data: {
        ..._tabContext.data,
        selectedReplacementDevice: data,
      },
    });

    setShowForm(true);
  };

  const handleDeleteReplacementDevice = (data, selectionStatus) => {
    try {
      const _gridRecord = replacementDeviceRecordList.map(item => {
        if (item.id === data.id) {
          return {
            ...item,
            deleted: selectionStatus,
            recordResponse: {
              ...item.recordResponse,
              Deleted: selectionStatus,
            },
          };
        }
        return item;
      });

      setReplacementDeviceRecordList(_gridRecord);
      _tabContextObject.setTabFormContext({
        data: {
          ..._tabContext.data,
          replacementDevice: _gridRecord,
        },
      });

      // Check if at least one record has deleted set to false
      const hasActiveRecords = _gridRecord.some(item => !item.deleted);
      if (!hasActiveRecords) {
        notifyToast("Replacement device is mandatory", ToastType.ERROR);
      }
      setIsFormValid(hasActiveRecords);

    } catch (err) {
      alert(err);
    }
  };

  const handlePageSizeChange = (newPageSize) => {
    setDataGridPageSize(newPageSize);
  };

  const actionConfigs = [
    {
      icon: MdCreate,
      onClick: handleEditReplacementDeviceClick,
      buttonColor: "#EEEEE",
      action: "edit",
    },
  ];

  const buttonConfigs = [
    {
      buttonText: <AddIcon />,
      buttonType: "filled",
      onClick: onAddClick,
      buttonColor: "#A62B23",
      textColor: "#fff",
      action: "create",
    },
  ];

  const dataGridSchema = [
    {
      field: "StartFrequencyReposition",
      headerName: t("replacementDevice.startFrequency"),
      flex: 1,
    },
    {
      field: "EndFrequencyReposition",
      headerName: t("replacementDevice.endFrequency"),
      flex: 1,
    },
    {
      field: "RepositionPercentage",
      headerName: t("replacementDevice.repositionPercentage"),
      flex: 1,
    },
    !IsLoggedInUserViewer() && {
      field: "deleted",
      headerName: "Mark for Delete",
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Checkbox defaultChecked={false} onChange={(e) => handleDeleteReplacementDevice(params.row, e.target.checked)} />
      ),
    },
    {
      field: "action",
      headerName: t,
      flex: 1,
      sortable: false,
      renderCell: (params) => <GridAction actionsConfig={actionConfigs} row={params.row} />,
    },
  ];

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ fontWeight: "bold", height: "30px" }}>{t("createReplacementDevices.listHeader")}</div>
        <ButtonGroup buttons={buttonConfigs} />
      </div>

      <DataGridRange
        rows={replacementDeviceRecordList}
        columns={dataGridSchema}
        pageSize={dataGridPageSize}
        pageSizeOptions={gridPageSizeOptions}
        onPageSizeChange={handlePageSizeChange}
        totalRowCount={totalReplacementDevice}
        toolbarHeader=""
        toolbarFilterPlaceholder={t("quoteApproval.toolbarFilterPlaceholder")}
      />
    </>
  );
};

export default ReplacementDeviceList;
